import { render, staticRenderFns } from "./CompareDetail.vue?vue&type=template&id=18471820&"
import script from "./CompareDetail.vue?vue&type=script&lang=js&"
export * from "./CompareDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports